export default {"src":"/_next/static/media/VNO.7ad81ec5.svg","height":18,"width":18};